import { Container, CssBaseline } from '@mui/material'

export function ErrorPage({ text }: { text: string }) {
  return (
    <Container component="main" sx={{ fontSize: 35 }}>
      <CssBaseline />
      <div className="flex flex-col items-center w-full mt-[30%]">
        <img className="w-36 m-4" src="/error.svg" alt="error icon" />
        <p className="text-lg text-center w-[85%]">{text}</p>
      </div>
    </Container>
  )
}
